<template>
  <el-select
    filterable
    remote
    clearable
    multiple
    :remote-method="loadTicketUserList"
    v-model="projectIds"
    @clear="onClear"
    @focus="onFocus"
    @change="onChange"
    placeholder="工单所属项目">
    <el-option v-for="item in projectList"
      :key="item.id"
      :label="item.name"
      :value="item.id"/>
  </el-select>
</template>

<script>
export default {
    name: 'TicketProjectSelect',

    props: ['ticketNo', 'value'],

    data() {
        return {
            projectIds: null,

            projectList: []
        }
    },

    watch: {
        value() {
            this.projectIds = this.value;
        },

        ticketNo() {
            this.on_ticketNo();
        }
    },

    methods: {
        clearValue() {
            this.projectIds = [];
        },

        onChange() {
            this.$emit('input', this.projectIds); // input 在 change 前

            this.$emit('change', this.projectIds);
        },

        onFocus() {},

        onClear() {},

        loadTicketUserList() {},

        loadProjectList() {
            var _this = this;

            sdk.ProjectApi().listByOrganizationId().then(res => {
                _this.projectList = res || [];
            });
        },

        on_ticketNo() {
            if ( !this.ticketNo ) {
                return;
            }

            var _this = this;

            sdk.ProjectTicketApi().listProjectIdByTicketNo({
                ticketNo: _this.ticketNo
            }).then(res => {
                _this.projectIds = res;
            });
        }
    },

    mounted() {
        this.loadProjectList();

        this.on_ticketNo();

        this.projectIds = this.value;
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketProjectSelect.vue